import type { RosterMovementBand, RosterMovementRow } from "./types";

export const ROSTER_MOVEMENT_PREVIEW_LIMIT = 3;

export type MovementBandPreview<T> = {
  preview: T[];
  total: number;
  hasMore: boolean;
};

export type MovementBandGroups = {
  joined: RosterMovementRow[];
  left: RosterMovementRow[];
  inMemoriam: RosterMovementRow[];
};

function sortByOccurredAtDesc(rows: RosterMovementRow[]): RosterMovementRow[] {
  return [...rows].sort((left, right) => right.occurredAt.localeCompare(left.occurredAt));
}

export function groupMovementRowsByBand(rows: RosterMovementRow[]): MovementBandGroups {
  const joined: RosterMovementRow[] = [];
  const left: RosterMovementRow[] = [];
  const inMemoriam: RosterMovementRow[] = [];

  for (const row of rows) {
    if (row.band === "joined") {
      joined.push(row);
    } else if (row.band === "left") {
      left.push(row);
    } else if (row.band === "inMemoriam") {
      inMemoriam.push(row);
    }
  }

  return {
    joined: sortByOccurredAtDesc(joined),
    left: sortByOccurredAtDesc(left),
    inMemoriam: sortByOccurredAtDesc(inMemoriam)
  };
}

export function buildMovementBandPreview(
  rows: RosterMovementRow[],
  limit = ROSTER_MOVEMENT_PREVIEW_LIMIT
): MovementBandPreview<RosterMovementRow> {
  return {
    preview: rows.slice(0, limit),
    total: rows.length,
    hasMore: rows.length > limit
  };
}

export function hasAnyMovementRows(bands: MovementBandGroups): boolean {
  return bands.joined.length > 0 || bands.left.length > 0 || bands.inMemoriam.length > 0;
}

export function movementBandLabel(band: RosterMovementBand): string {
  if (band === "joined") {
    return "JOINED SECTION · 30D";
  }

  if (band === "left") {
    return "LEFT SECTION · 30D";
  }

  return "IN MEMORIAM";
}
